import { Ref, forwardRef, useState } from "react";
import { clsx } from "clsx";
import { Facet } from "../facet/Facet";
import {
  Data,
  FacetChangeEvent,
  FacetsType,
  LinksType,
  PageData,
  ResourcedTexts,
} from "../SearchFilterResultData";
import { Links } from "../links/Links";

type SidebarProps = {
  facets: FacetsType;
  onFacetChange: FacetChangeEvent;
  links: LinksType;
  searchTerm: string;
  loading: boolean;
  resourcedTexts: ResourcedTexts;
  onClearFilter: () => void;
};

export function sidebarHasContent({ facets }: Data, { links }: PageData) {
  const hasFacets = facets.length > 0;
  const hasLinks = links && links.length > 0;

  return hasFacets || hasLinks;
}

export const Sidebar = forwardRef(ForwardedSidebar);

function ForwardedSidebar(
  {
    facets = [],
    onFacetChange,
    links,
    searchTerm,
    resourcedTexts,
    onClearFilter,
    loading,
  }: SidebarProps,
  ref: Ref<HTMLDivElement>
) {
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  function openMobileSidebar() {
    document.body.classList.add("mobile-sidebar-open");
    setIsMobileSidebarOpen(true);
  }

  function closeMobileSidebar() {
    document.body.classList.remove("mobile-sidebar-open");
    setIsMobileSidebarOpen(false);
  }

  return (
    <div className="sidebar" ref={ref}>
      <div className="sidebar__bar-wrapper hide-for-medium">
        <div className="sidebar__bar">
          <button type="button" className="button sidebar__toggle" onClick={openMobileSidebar}>
            {resourcedTexts.filterButton}
          </button>
        </div>
      </div>

      <div className={clsx("sidebar__wrapper", isMobileSidebarOpen && "active")}>
        <div className="sidebar__header">
          <h2 className="sidebar__title">{resourcedTexts.filterTitle}</h2>

          <button
            type="button"
            className="sidebar__clear"
            title={resourcedTexts.clearFilter}
            onClick={() => onClearFilter()}
            disabled={loading}
          >
            {resourcedTexts.clearFilter}
          </button>

          <button
            type="button"
            className="sidebar__close hide-for-medium"
            onClick={closeMobileSidebar}
          >
            {resourcedTexts.closeFilter}
          </button>
        </div>

        <Links links={links} searchTerm={searchTerm} />

        {facets.map((facet) => (
          <Facet
            key={facet.id}
            facet={facet}
            onChange={onFacetChange}
            resourcedTexts={resourcedTexts}
            disabled={loading}
          />
        ))}

        <button type="button" className="show-for-small-only" onClick={closeMobileSidebar}>
          {resourcedTexts.filterSubmit}
        </button>
      </div>
      {loading && <div className="sidebar__overlay" />}
    </div>
  );
}
